<template>
  <main class="adm-wrap">
    <div class="adm-inner">

      <div class="adm-page-title">
        호텔 추가안내 템플릿 {{ isEdit ? '수정' : '등록' }}
      </div>

      <table class="adm-table">
        <colgroup>
          <col style="width: 160px;">
          <col>
        </colgroup>
        <tbody>

          <tr>
            <th>안내 코드 <span class="req">*</span></th>
            <td>
              <!-- disabled로 인한 단방향 표시이므로 :value로 -->
              <input type="text" class="adm-input text-success" :value="isEdit ? addInfoCode : form.addInfoCode" disabled />
            </td>
          </tr>

          <tr>
            <th>제목 <span class="req">*</span></th>
            <td>
              <input type="text" class="adm-input" v-model="form.addTitle"
                placeholder="예) 2026년 일본 숙박관련 추가안내" />
            </td>
          </tr>

          <tr>
            <th>안내 내용 <span class="req">*</span></th>
            <td>
              <textarea class="adm-textarea" v-model="form.addContent"
                maxlength="2000"
                placeholder="고객에게 표시될 추가 안내 내용을 입력하세요.&#10;예)오사카숙박세: 1,000엔 || 온천세: 200엔&#10;체크인 시 현장결제">
              </textarea>
              <div class="adm-charcount">
                <span :class="{ 'adm-charcount--warn': (form.addContent || '').length >= 1000 }">
                  {{ (form.addContent || '').length }}
                </span>
                / 1,000자
              </div>
            </td>
          </tr>

          <tr>
            <th>안내 적용 기간 <span class="req">*</span></th>
            <td>
              <div class="adm-date-row">
                <input type="date" class="adm-input adm-input--date" v-model="form.addUseStart" />
                <span class="adm-date-sep">~</span>
                <input type="date" class="adm-input adm-input--date" v-model="form.addUseClose" />
              </div>
              <span class="adm-hint">투숙일(체크인)이 설정기간에 포함될 때 안내표시</span>
            </td>
          </tr>

          <tr>
            <th>사용여부</th>
            <td>
              <label class="adm-radio-label">
                <input type="radio" v-model="form.addUseFlag" value="Y" /> 사용
              </label>
              <label class="adm-radio-label" style="margin-left:16px;">
                <input type="radio" v-model="form.addUseFlag" value="N" /> 미사용
              </label>
            </td>
          </tr>

          <tr>
            <th></th>
            <td>
              <div class="adm-notice">
                <div>· 안내 내용은 예약 2단계(투숙객 입력) 화면하단표시</div>
                <div>· 투숙일(체크인일)이 적용기간 중인 경우 표시</div>
                <div>· 숙박세, 온천세 등 현장 납부 항목을 안내목적</div>
              </div>
            </td>
          </tr>

        </tbody>
      </table>

      <div class="adm-actions">
        <button type="button" class="adm-btn adm-btn--sub" @click="goToList">리스트</button>
        <button type="button" class="adm-btn adm-btn--primary" @click="save">저장</button>
      </div>

    </div>
  </main>
</template>

<script>
import { genCode } from '../assets/js/genCode';        // 안내코드생성

export default {
  name: 'RakutenAddInfoForm',

  data() {
    return {
      form: {
        addInfoCode: '',
        addTitle:    '',
        addContent:  '',
        addUseFlag:  'Y',
        addUseStart: '',
        addUseClose: '',
      },
      isEdit: false,
      seqNo:  null,
    };
  },

  computed: {
    user() { return this.$store.state.user; },
  },

  created() {
    // 수정 모드: query로 code 전달
    console.log('query:', this.$route.query.aICode)
    if (this.$route.query.aICode) 
    {
      this.isEdit = true;
      this.addInfoCode  = this.$route.query.aICode;
      this.loadData();
    }
  },

  mounted() {
    if (this.user.handlerGrade >= 20) {
      this.$swal.fire({ title: '접근 불가', icon: 'error' });
      this.$router.push({ path: '/' });
    }
    document.getElementById('user').style.display = 'none';
  },

  methods: {
    // 날짜 포맷터(공통함수)
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    // 안내코드생성
    async genCode(param) {
      //let addInfoCode = await this.genCode("AD")
      // let chkFlag = "N";
      let rtnCode = "";
      const today_tmp = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
      let today_ymd = today_tmp.replace(/-/g, ''); // YYYYMMDD      
      let dCd = param + today_ymd;

      const MAX_ATTEMPTS = 10;      

      for (let i = 0; i < MAX_ATTEMPTS; i++) 
      {
        rtnCode = await genCode(this.$api, dCd);
        const dub  = await this.$api('/api/rakutenAddInfoOne', { param: [rtnCode] });

        if (!dub || dub.length < 1) return rtnCode;                    // 중복 없으면 즉시 반환
      }

      this.$swal.fire('', '안내코드 생성 한계 도달. 담당자 문의(1660-4602)', 'warning');
      return null;
    },

    async loadData() {
      let result = await this.$api('/api/rakutenAddInfoOne',  {param: [
        this.addInfoCode
      ]});

      if (result.length > 0) 
      {
        this.form.addInfoCode = result[0].addInfoCode
        this.form.addTitle    = result[0].addTitle   
        this.form.addContent  = result[0].addContent 
        this.form.addUseFlag  = result[0].addUseFlag
        this.form.addUseStart = this.getDateFormat(result[0].addUseStart);
        this.form.addUseClose = this.getDateFormat(result[0].addUseClose);
      }
    },

    validate() {
      if (!this.form.addInfoCode.trim()) 
      {
        this.$swal.fire('안내코드가 부정확합니다'); return false;
      }

      if (!this.form.addTitle.trim()) 
      {
        this.$swal.fire('제목을 입력하세요.'); return false;
      }

      if (!this.form.addContent.trim()) 
      {
        this.$swal.fire('안내 내용을 입력하세요.'); return false;
      }

      if (!this.form.addUseStart || !this.form.addUseClose) 
      {
        this.$swal.fire('적용 기간을 입력하세요.'); return false;
      }

      if (this.form.addUseStart > this.form.addUseClose) 
      {
        this.$swal.fire('시작일이 종료일보다 늦을 수 없습니다.'); return false;
      }
      return true;
    },

    async save() {
      if (!this.isEdit) 
      {
        let rtnCode = await this.genCode("AD");
        if (!rtnCode) 
        {
          this.$swal.fire('', '안내코드 생성 실패. 담당자 문의(1660-4602)', 'error');
          return;
        }
        this.form.addInfoCode = rtnCode;
      }

      if (!this.validate()) return;

      let obj_addInfo = {
        ...this.form,
        updId:   this.user.handlerId,
        // updDate: new Date().toISOString().slice(0, 19).replace('T', ' '),
      };

      let result;
      if (this.isEdit)
      {
        result = await this.$api('/api/rakutenAddInfoUpdate', {param: [
            obj_addInfo.addTitle, obj_addInfo.addContent, obj_addInfo.addUseFlag, obj_addInfo.addUseStart, obj_addInfo.addUseClose, obj_addInfo.updId, obj_addInfo.addInfoCode
          ]});
      } 
      else 
      {
        obj_addInfo.insId   = this.user.handlerId;
        result = await this.$api('/api/rakutenAddInfoInsert', {param: 
          [ obj_addInfo.addInfoCode, obj_addInfo.addTitle, obj_addInfo.addContent, obj_addInfo.addUseFlag, obj_addInfo.addUseStart, obj_addInfo.addUseClose, obj_addInfo.insId]
        });
      }

      if (result?.affectedRows >= 1) 
      {
        this.$swal.fire('', '저장완료', 'success');
        this.$router.push({ path: '/ma_AddInfoList' });
      } 
      else 
      {
        this.$swal.fire('', '저장실패', 'error');
      }
    },

    goToList() {
      this.$router.push({ path: '/ma_AddInfoList' });
    },
  }
};
</script>

<style scoped>
.adm-wrap {
  padding: 28px 20px 60px;
  background: #f5f5f5;
  min-height: 100vh;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1rem;
  color: #222;
}

.adm-inner {
  max-width: 1000px;
  margin: 0 auto;
}

.adm-page-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #222;
}

/* 테이블 */
.adm-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #d0d0d0;
}

.adm-table th,
.adm-table td {
  padding: 11px 14px;
  border-bottom: 1px solid #e8e8e8;
  vertical-align: middle;
  text-align: left;
}

.adm-table th {
  background: #f9f9f9;
  font-weight: 600;
  color: #444;
  white-space: nowrap;
}

.adm-table tr:last-child th,
.adm-table tr:last-child td {
  border-bottom: none;
}

.req { color: #d32f2f; margin-left: 2px; }

/* 입력 요소 공통 */
.adm-sel,
.adm-input {
  height: 32px;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 13px;
  font-family: inherit;
  color: #222;
  background: #fff;
}

.adm-sel:focus,
.adm-input:focus {
  outline: none;
  border-color: #86cd53;
}

.adm-sel { padding-right: 4px; }
.adm-sel--sm { width: 130px; }
.adm-input { width: 100%; box-sizing: border-box; }

.adm-hint {
  margin-left: 10px;
  font-size: 12px;
  color: #d32f2f;
  font-weight: 600;
}

/* 텍스트에어리어 */
.adm-textarea {
  width: 100%;
  height: 220px;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  line-height: 1.65;
  color: #222;
  resize: vertical;
  box-sizing: border-box;
}

.adm-textarea:focus {
  outline: none;
  border-color: #86cd53;
}

.adm-charcount {
  text-align: right;
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.adm-charcount--warn { color: #d32f2f; font-weight: 700; }

/* 안내 */
.adm-notice {
  font-size: 12px;
  color: #666;
  line-height: 1.9;
}

.adm-notice .red { color: #d32f2f; }

/* 버튼 */
.adm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.adm-btn {
  height: 34px;
  padding: 0 20px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
}

.adm-btn--primary {
  background: #86cd53;
  color: #fff;
  border-color: #6ab840;
}

.adm-btn--primary:hover { background: #6ab840; }

.adm-btn--sub {
  background: #fff;
  color: #555;
  border-color: #bbb;
}

.adm-btn--sub:hover { background: #f0f0f0; }

.adm-date-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.adm-input--date {
  width: 150px;
}
.adm-date-sep {
  color: #888;
  font-weight: 600;
}
.adm-radio-label {
  font-size: 13px;
  color: #444;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.adm-radio-label input[type="radio"] {
  accent-color: #86cd53;
  cursor: pointer;
}
</style>